document.addEventListener('DOMContentLoaded', () => {
  const headlines = document.querySelectorAll('[data-headline]')
  const overlay = document.querySelector('[data-overlay]')
  const loginBtn = document.querySelectorAll('[data-login-btn]')
  const loginModal = document.querySelector('[data-login]')
  /*   const logOutBtn = document.querySelectorAll('[data-log-out-btn]') */
  const anchorLink = document.querySelectorAll('[data-anchor-link]')
  const isLandingPage = document.querySelector('[data-landing-page]')
  const ctaLinks = document.querySelectorAll('[data-cta-links]')
  const myPageBtn = document.querySelector('[data-mypage-btn]')
  const myPageLinks = document.querySelector('[data-mypage-links]')

  const updateCartCount = totalQuantity => {
    const cartCountElements = document.querySelectorAll('[data-cart-count]')
    cartCountElements.forEach(cartCountElement => {
      cartCountElement.textContent = totalQuantity
    })
  }

  document.addEventListener('cartQuantityUpdated', (event: CustomEvent) => {
    if (event.detail && event.detail.totalQuantity !== undefined) {
      updateCartCount(event.detail.totalQuantity)
    }
  })

  const trapFocus = element => {
    const focusableElements = element.querySelectorAll('a, button, input, select, textarea')
    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    element.addEventListener('keydown', event => {
      const isTabPressed = event.key === 'Tab' || event.keyCode === 9

      if (!isTabPressed) {
        return
      }

      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus()
          event.preventDefault()
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus()
          event.preventDefault()
        }
      }
    })
  }

  loginBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      loginModal.classList.toggle('hidden')
      if (!loginModal.classList.contains('hidden')) {
        trapFocus(loginModal)
        ;(loginModal.querySelector('a, button, input, select, textarea') as HTMLElement).focus()
      }
    })
  })

  if (isLandingPage) {
    ctaLinks.forEach(link => {
      link.classList.add('lg:!hidden')
    })
  }

  const toggleMegaMenu = event => {
    const megamenuContent = event.currentTarget.nextElementSibling
    const isOpen = megamenuContent.classList.contains('open')
    document.querySelectorAll('[data-megamenu-content].open').forEach(content => {
      if (content !== megamenuContent) {
        content.classList.remove('open')
        content.classList.add('hidden')
        content.setAttribute('aria-hidden', 'true')
        setTabIndex(content, -1)
        content.previousElementSibling.classList.remove('text-dania-red-700')
        content.previousElementSibling.setAttribute('data-active', 'false')
      }
    })

    if (isOpen) {
      event.currentTarget.setAttribute('aria-expanded', 'false')
      megamenuContent.classList.remove('open')
      megamenuContent.classList.add('hidden')
      megamenuContent.setAttribute('aria-hidden', 'true')
      megamenuContent.setAttribute('tabindex', '-1')
      setTabIndex(megamenuContent, -1)
      event.currentTarget.classList.remove('text-dania-red-700')
      event.currentTarget.setAttribute('data-active', 'false')
      if (!document.querySelector('[data-megamenu-content].open')) {
        overlay.setAttribute('data-overlay', '')
      }
    } else {
      event.currentTarget.setAttribute('aria-expanded', 'true')
      megamenuContent.classList.remove('hidden')
      setTimeout(() => {
        megamenuContent.classList.add('open')
        megamenuContent.setAttribute('aria-hidden', 'false')
        megamenuContent.setAttribute('tabindex', '0')
        setTabIndex(megamenuContent, 0)
        megamenuContent.querySelector('a').focus()
      }, 10)
      event.currentTarget.classList.add('text-dania-red-700')
      event.currentTarget.setAttribute('data-active', 'true')
      overlay.setAttribute('data-overlay', 'active')
    }
  }

  const closeAllMenus = () => {
    document.querySelectorAll('[data-megamenu-content].open').forEach(content => {
      const headline = content.previousElementSibling
      headline.setAttribute('aria-expanded', 'false')
      content.classList.remove('open')
      content.classList.add('hidden')
      content.setAttribute('aria-hidden', 'true')
      setTabIndex(content, -1)
      headline.classList.remove('text-dania-red-700')
      headline.setAttribute('data-active', 'false')
    })
    overlay.setAttribute('data-overlay', '')
    loginModal.classList.add('hidden')
  }

  headlines.forEach(headline => {
    headline.addEventListener('click', toggleMegaMenu)

    headline.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        toggleMegaMenu.call(headline, event)
      }
    })
  })

  anchorLink.forEach(link => {
    link.addEventListener('click', _event => {
      closeAllMenus()
    })
  })
  

  if(overlay) {
    overlay.addEventListener('click', closeAllMenus)
  }

  const setTabIndex = (container, index) => {
    let focusableItems = container.querySelectorAll('a, button, input, select, textarea')
    focusableItems.forEach(item => {
      item.tabIndex = index
    })
  }

  if (myPageBtn) {
    myPageBtn.addEventListener('click', () => {
      myPageLinks.classList.toggle('hidden')
      const classesToToggle = ['!text-dania-red-700', '!bg-white', '!outline', '!outline-1', '!outline-dania-red-700', '[&_svg]:rotate-180']

      classesToToggle.forEach(className => {
        myPageBtn.classList.toggle(className)
      })
    })
  }
})
